import webStorage from '@/utils/web-storage'
import * as services from '@/services'
import { languages } from '@/utils/languages'

const STORAGE_KEY = 'exercises-settings'

const defineDefaultSettings = () => {
  const settings = webStorage.get(STORAGE_KEY) || {}

  const isCorrectAnswerExplanations =
    'isCorrectAnswerExplanations' in settings
      ? settings.isCorrectAnswerExplanations
      : true

  const explanationLanguage =
    'explanationLanguage' in settings ? settings.explanationLanguage : 'English'

  return {
    isCorrectAnswerExplanations,
    explanationLanguage
  }
}

export default {
  namespaced: true,

  state: {
    exercises: {
      list: [],
      history: [],

      activeIndex: 0
    },

    settings: defineDefaultSettings()
  },

  getters: {
    activeExercise: state => state.exercises.list[state.exercises.activeIndex],

    activeExplanationLanguageObject: state =>
      languages.find(
        language => language.englishName === state.settings.explanationLanguage
      ),

    defineIsCorrect:
      () =>
      ({ exercise, answer }) =>
        exercise.answers[0] === answer,

    totalCorrectAnswers: state => {
      return state.exercises.history.filter(item => item.isCorrect).length
    },

    isFinished: state =>
      state.exercises.history.length >= state.exercises.list.length

    // totalIncorrectAnswers: state => {
    //   return state.exercises.history.filter(item => !item.isCorrect).length
    // }
  },

  actions: {
    async GENERATE_EXPLANATION({ state }, { historyItem }) {
      const result = await services.openai.generateExplanation({
        historyItem,
        language: state.settings.explanationLanguage
      })

      return result
    }
  },

  mutations: {
    SET_LIST(state, list) {
      state.exercises.list = list.slice(0, 10)
      state.exercises.history = []
      state.exercises.activeIndex = 0
    },

    ADD_TO_HISTORY(state, historyItem) {
      state.exercises.history.push(historyItem)
    },

    SET_ACTIVE_INDEX(state, index) {
      state.exercises.activeIndex = index
    },

    SET_IS_CORRECT_ANSWER_EXPLANATIONS(state, value) {
      state.settings.isCorrectAnswerExplanations = value

      // Save to localStorage
      const currentSettings = webStorage.get(STORAGE_KEY) || {}
      currentSettings.isCorrectAnswerExplanations = value
      webStorage.set(STORAGE_KEY, currentSettings)
    },

    SET_EXPLANATION_LANGUAGE(state, value) {
      state.settings.explanationLanguage = value

      // Save to localStorage
      const currentSettings = webStorage.get(STORAGE_KEY) || {}
      currentSettings.explanationLanguage = value
      webStorage.set(STORAGE_KEY, currentSettings)
    }
  }
}
